'use client';

import { ArrowLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';
import React from 'react';

interface LocationPickerHeaderProps {
  onBackClick: () => void;
}

export const LocationPickerHeader: React.FC<LocationPickerHeaderProps> = ({ onBackClick }) => {
  const t = useTranslations();

  return (
    <header className="w-full border-b border-neutral-200 p-2 sticky top-0 z-50 bg-white">
      <div className="flex items-center">
        <button onClick={onBackClick} className="p-3 cursor-pointer" aria-label="Go back">
          <ArrowLeft className="text-neutral-900" size={22} />
        </button>
        <h1 className="text-base font-medium text-neutral-900">{t('SearchPage.chooseLocation')}</h1>
      </div>
    </header>
  );
};
